// extracted by mini-css-extract-plugin
export default {"sandboxScrollbarTheme":"Scrollbar_sandboxScrollbarTheme__aCo9N","sandboxScrollbarThemeSmall":"Scrollbar_sandboxScrollbarThemeSmall__byxnD"};